import { Navigate, useLocation } from 'react-router-dom'
import { useSession } from '@shared/hooks/useSession'
import { ReactNode } from 'react'

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { data, isLoading, error } = useSession()
  const loc = useLocation()
  if (isLoading) return <div className="p-6">Loading…</div>
  if (error) return <div className="p-6 text-danger">Error loading session</div>
  if (!data?.authenticated) return <Navigate to="/login" replace state={{ from: loc }} />
  if (data.needs_email_verify) return <Navigate to="/verify-email" replace />
  if (data.needs_mfa) return <Navigate to="/mfa" replace />
  return <>{children}</>
}

